import './styles/style.scss';
import { app } from './scripts/app';
document.addEventListener('DOMContentLoaded', function () {
    console.log('Start script!');
    app.start();
    // app.testSevice();
});
